import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const CartTranslations = wrapTranslationsSchema({
	name: 'CartTranslations',
	title: 'Cart Translations',
	sanityId: 'cart',
	fields: {
		totalSavedItemsOne: '{count} saved item',
		totalSavedItemsOther: '{count} saved items',
		selectAll: 'Select all',
		startRequest: 'Start a request',
		saveForLater: 'Save for later',
		savedForLater: 'Saved for later',
		submitRequest: 'Submit request',
		continueRequest: 'Continue Request',
		saveBundleForLater: 'Save selected items for later',
		itemIsInSaveForLaterMessage:
			'To continue a previously started request, [click here.]({cartUrl})',
		deleteFromCart: 'Delete',
		deleteCancel: 'Cancel',
		deleteMultipleOne: 'Delete {count} item',
		deleteMultipleOther: 'Delete {count} items',
		deleteConfirmationTitle: 'Delete this item?',
		deleteMultipleConfirmationTitleOne: 'Delete {count} item?',
		deleteMultipleConfirmationTitleOther: 'Delete {count} items?',
		deleteConfirmationMessage:
			'Are you sure you want to delete this item from the Saved for Later list? This action cannot be undone.',
		deleteMultipleConfirmationMessage:
			'Are you sure you want to delete these items from the Saved for Later list? This action cannot be undone.',
		store: 'Store:',
		bundle: 'Bundle:',
		requestFor: 'Request for:',
		price: 'Price:',
		estimatedFulfillmentTime: 'Estimated fulfillment time:',
		readyToSubmit: 'Ready to submit:',
		ready: 'READY',
		notReady: 'NOT READY',
		notReadyMessage: 'Mandatory fields are missing from the form.',
		details: 'Details:',
		quantity: 'Quantity',
		total: 'Total:',
		editRequestForm: 'Edit Request Form',
		summary: 'Summary',
		itemCountOne: ' {count} item:',
		itemCountOther: ' {count} items:',
		submitSelected: 'Submit selected',
		noItemsSelected: 'No item selected',
		emptySavedForLaterMessage: 'You’re all caught up! You have no saved items.',
		showBundleItems: 'Show items included in this bundle',
		addedModalTitleAdded: 'Item was saved for later',
		addedModalViewCart: 'View all saved items',
		addedModalContinue: 'Continue browsing',
		addedModalRequestedFor: 'Requested for:',
		addedModalPrice: 'Price:',
		addedModalStore: 'Store:',
		submitRequestModalTitle: 'Are you sure you want to submit?',
		submitRequestModalDescription:
			'Some items you selected are missing mandatory fields and cannot be submitted. Do you still want to proceed? You can go back to complete the form and try again.',
		submitRequestModalCancel: 'Cancel',
		submitRequestModalSubmit: 'Submit',
		submitRequestModalNotReadyItemMessage:
			'Please complete all required form fields so that this request may be sent for fulfillment.',
		na: 'N/A',
		requestsPageTitle: 'Requests',
	},
});
